import { IBackgroundImage } from '../components';
import { TCreateBackgroundImageFn } from './types';

const imgConverter = (img: HTMLImageElement): IBackgroundImage => ({
  width: img.width,
  height: img.height,
  uri: img.src,
  naturalWidth: img.naturalWidth,
  naturalHeight: img.naturalHeight,
});

export const createBackgroundImage: TCreateBackgroundImageFn = (
  imageSrc: string,
  onload: (i?: IBackgroundImage) => void
): (() => void) => {
  const img = document.createElement('img');
  img.src = imageSrc;

  img.onload = () => {
    const convertedImage = imgConverter(img);
    onload(convertedImage);
  };
  img.onerror = (err) => {
    console.error('Failed to load floor plan image:', err);
    onload(undefined);
  };

  return () => {
    img.onload = null;
    img.onerror = null;
  };
};
